angular.module('rjmNg.directives').directive 'resizeFigurePresentation', [
  "$timeout"
  "utils"
  (
    $timeout
    utils
  ) ->
    restrict: "A"
    replace: false
    priority: 200
    require: [
      "?renderHighchart"
      "?renderTable"
      "?renderScalar"
    ]
    link: (scope, elem, attrs, controllers) ->
      # This checks that the resizeFigurePresentation directive
      # element has at least one of the appropriate controllers
      # attached to it.
      resizeFunction = null
      _onLink = () ->
        for controller in controllers when controller?
          resizeFunction = controller.resizeFunction
        unless resizeFunction?
          exception = """The resizeFigurePresentation directive must be accompanied by
          a single figurePresentation rendering directive (renderHighchart, renderFigure, renderScalar)
          with a resizeFunction property set."""
          throw exception

        scope.widthModifier = utils.readIntAttribute(attrs.widthModifier)
        scope.heightModifier = utils.readIntAttribute(attrs.heightModifier)

      _resize = (width, height) ->
        elem.parent().addClass("blocked")

        # Setting the final argument of timeout to false skips dirty checking,
        # so the resizeFunction is called only after the digest loop exits.

        $timeout =>
          resizeFunction(width + scope.widthModifier, height + scope.heightModifier)
          elem.parent().removeClass("blocked")
        , 0
        , false

      scope.$on "gridsterItemResized", (event, width, height) ->
        _resize width, height

      scope.$on "enlargedDashboardItemResized", (event, width, height) ->
        _resize width, height

      _onLink()
]
